import {GetArrayFromRecursive, GetFlatArrayFromRecursive} from "../../helpers/CoreHelpers";

const initialState = {
    items: [],
    single: {},
    refresh: false,
    loading: false,
    filtered: [],
    flat: [],
    select: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'WIDGETS_RESET':
            return initialState;
        case 'WIDGETS_STRUCTURE_LOADING':
            if (action.payload.skipStore === false) {
                return {
                    ...state,
                    loading: true
                }
            } else {
                return {
                    ...state
                }
            }
        case 'WIDGETS_STRUCTURE_SUCCESS':
            if (action.payload.skipStore === false) {
                return {
                    ...state,
                    items: action.payload.data,
                    filtered: action.payload.data,
                    flat: GetFlatArrayFromRecursive(action.payload.data),
                    select: GetArrayFromRecursive(action.payload.data),
                    loading: false
                };
            } else {
                return {
                    ...state
                }
            }
        case 'WIDGETS_STRUCTURE_FAILED':
            if (action.payload.skipStore === false) {
                return {
                    ...state,
                    loading: false
                }
            } else {
                return {
                    ...state
                }
            }
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/widgets.js